<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >
                    <div class="row hidden-lg hidden-xl">

                        <div class="col-lg-8 col-md-7 col-xs-12 col-xl-5">
                            <div class="tabs tabs-default margin-top-0 margin-bottom-25">
                                <div class="tabs-header">
                                    <ul style="width: 100%;">
                                        <li style="width: 50%;" v-bind:class="{'active': tab == 'receitas'}">
                                            <a v-on:click="setTab('receitas')">
                                                Receitas
                                            </a>
                                        </li>
                                        <li style="width: 50%;" v-bind:class="{'active': tab == 'atestados'}">
                                            <a v-on:click="setTab('atestados')">
                                                Atestados
                                            </a>
                                        </li>                                    
                                    </ul>
                                </div>
                            </div>
                        </div> 
                    </div> 

                    <div class="header-image-gradient" style="background-image: url(static/images/img1.jpg); margin-top: -27px; background-position: top;">
                        <div class="layer-gradient"></div>
                    </div>

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>
                            {{$router.currentRoute.meta.title}}
                        </h3>
                    </div>
                        
                    <div class="row hidden-md hidden-xs">

                        <div class="col-lg-8 col-md-7 col-xs-12 col-xl-5">
                            <a class="button margin-bottom-20 margin-right-5" v-on:click="setTab('receitas')" v-bind:class="{'color-primary': tab == 'receitas'}">
                                Receitas
                            </a>
                            <a class="button outline margin-bottom-20" v-on:click="setTab('atestados')" v-bind:class="{'color-primary': tab == 'atestados'}">
                                Atestados                                
                            </a>                            
                        </div> 
                    </div> 

                    <!-- Row -->
                    <div class="row" v-if="tab == 'receitas'">
                       
                        <div class="col-lg-12 col-xs-12 col-xl-6" v-show="!form.CD_PESSOA_FISICA">
                            <p class="page-text margin-bottom-20 margin-top-0" v-if="$root.user.tipo == 'contratante'">
                                Visualize abaixo as suas receitas digitais.
                            </p>
                            <p class="page-text margin-bottom-20 margin-top-0" v-if="$root.user.tipo == 'profissional'">
                                Visualize abaixo as suas receitas digitais emitidas.
                            </p>                            
                            <h5 class="block-title">
                                <i class="las la-list"></i>
                                Recentes
                            </h5>
                        </div>  


                        <div class="col-xl-12">
                            <h5 v-if="data.itens.length == 0 && data.loaded" class="empty">
                                <i class="las la-times"></i>

                                Nenhum resultado encontrado.
                            </h5>
                        </div>                           

                        <div class="col-xl-12" v-for="(item, index) in data.itens">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="attachments-container margin-bottom-15">
                                        <div class="attachment-box">
                                            <span>
                                                <a v-on:click="open(item)" style="cursor: pointer;">
                                                    Receita 
                                                    {{item.IE_TIPO_RECEITA == 'C' ? 'Comum' : ''}}
                                                    {{item.IE_TIPO_RECEITA == 'A' ? 'Amarela' : ''}}
                                                    {{item.IE_TIPO_RECEITA == 'B' ? 'Branca de duas vias' : ''}}
                                                    {{item.IE_TIPO_RECEITA == 'Z' ? 'Azul' : ''}}
                                                    {{item.IE_TIPO_RECEITA == 'S' ? 'SUS' : ''}}
                                                </a>
                                            </span>
                                            <!-- <p v-html="item.DS_RECEITA"></p> -->
                                            <small>
                                                <!-- <div class="las la-info-circle"></div> -->
                                                <b>#{{item.NR_SEQUENCIA}}</b>
                                            </small>
                                            <small>
                                                <div class="las la-info-circle"></div>
                                                Atendimento: <b>#{{item.NR_ATENDIMENTO_HOSP}}</b>
                                            </small>                                            
                                            <small>
                                                <div class="las la-clock"></div>
                                                Emitida em <b>{{item.DT_RECEITA | formatDateTime}}</b>
                                            </small>  
                                            <small v-if="$root.user.tipo != 'profissional'">
                                                <div class="las la-user"></div>
                                                Emitida por <b>{{item.NM_MEDICO}}</b>
                                            </small>
                                            <small v-if="$root.user.tipo != 'contratante' && !form.CD_PESSOA_FISICA" v-on:click="$root.go('Paciente', JSON.stringify({'CD_PESSOA_FISICA': item.CD_PESSOA_FISICA}))">
                                               <div class="las la-user"></div>
                                                Paciente: <u><b>{{item.NM_PESSOA_FISICA}}</b></u>
                                            </small>                                                                            
                                            <div class="buttons">                                                    
                                                <button type="button" class="dashboard-status-button block-mobile color-secondary" v-on:click="open(item)">
                                                    <i class="las la-eye"></i>
                                                    Visualizar
                                                </button>
                                            </div>                                               
                                        </div>                                   
                                    </div>
                                </div>
                            </div>
                        </div>  
                    </div>

                    <div class="row" v-if="tab == 'atestados'">
                       
                        <div class="col-lg-12 col-xs-12 col-xl-6">
                            <p class="page-text margin-bottom-20 margin-top-0" v-if="$root.user.tipo == 'contratante'">
                                Visualize abaixo os seus atestados.
                            </p>
                            <p class="page-text margin-bottom-20 margin-top-0" v-if="$root.user.tipo == 'profissional'">
                                Visualize abaixo os seus atestados emitidas.
                            </p>                            
                            <h5 class="block-title">
                                <i class="las la-list"></i>
                                Recentes
                            </h5>
                        </div>     


                        <div class="col-xl-12">
                            <h5 v-if="data.itens.length == 0 && data.loaded" class="empty">
                                <i class="las la-times"></i>

                                Nenhum resultado encontrado.
                            </h5>
                        </div>                           

                        <div class="col-xl-12" v-for="(item, index) in data.itens">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="attachments-container margin-bottom-15">
                                        <div class="attachment-box">
                                            <span>
                                                <a v-on:click="open(item)" style="cursor: pointer;">
                                                    Atestado de {{item.QT_DIAS_ATESTADO}} dia(s)
                                                </a>
                                            </span>
                                            <!-- <p v-html="item.DS_RECEITA"></p> -->
                                            <small>
                                                <div class="las la-info-circle"></div>
                                                <b>#{{item.NR_SEQUENCIA}}</b>
                                            </small>
                                            <small>
                                                <div class="las la-info-circle"></div>
                                                Atendimento: <b>#{{item.NR_ATENDIMENTO}}</b>
                                            </small>           
                                            <small>
                                                <div class="las la-clock"></div>
                                                Emitida em <b>{{item.DT_LIBERACAO | formatDateTime}}</b>
                                            </small>  
                                            <small v-if="$root.user.tipo != 'profissional'">
                                                <div class="las la-user"></div>
                                                Emitida por <b>{{item.NM_MEDICO}}</b>
                                            </small>
                                            <small v-if="$root.user.tipo != 'contratante'  && !form.CD_PESSOA_FISICA" v-on:click="$root.go('Paciente', JSON.stringify({'CD_PESSOA_FISICA': item.CD_PESSOA_FISICA}))">
                                               <div class="las la-user"></div>
                                                Paciente: <u><b>{{item.NM_PESSOA_FISICA}}</b></u>
                                            </small>                                                                            
                                            <div class="buttons">                                                    
                                                <button type="button" class="dashboard-status-button block-mobile color-secondary" v-on:click="open(item)">
                                                    <i class="las la-eye"></i>
                                                    Visualizar
                                                </button>
                                            </div>                                               
                                        </div>                                   
                                    </div>
                                </div>
                            </div>
                        </div>  
                    </div>

                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Receitas',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];
            return date;

        },
        formatDateTime: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            return date + " " + time;
        }, 
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },        
    },    
    data () {
        var self                    = this;
        return {
            "tab":                  "receitas",
            "loaded":               false,
            "data":                 {
                "itens":            []
            },
            "loading": {
                "submit":           false
            },           
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token
            },
        }
    },
    watch: {
                  
    },
    methods: {               
        open: function(item) {
            var self        = this;
            console.log("open()", item);
            return new Promise(function(resolve, reject) {
                loading.show();
                if (item.DS_RECEITA) {
                    self.$root.openModal("modalReceita", "<div class='row'><div class='col-lg-12 margin-bottom-20'><h3>Detalhes da receita</h3><hr style='opacity: 0.3'></div><div class='col-xl-12'><div class='v-html2'>" + item.DS_RECEITA + "</div></div></div>"); 
                } else {
                    self.$root.openModal("modalReceita", "<div class='row'><div class='col-lg-12 margin-bottom-20'><h3>Detalhes do atestado</h3><hr style='opacity: 0.3'></div><div class='col-xl-12'><div class='v-html2'>" + item.DS_ATESTADO + "</div></div></div>"); 
                }
            });   
        },
        get: function() {
            var self        = this;
            console.log("get()");
            return new Promise(function(resolve, reject) {
                axios.get("api/" + self.tab + ".php", {params: self.form})
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data           = JSON.parse(JSON.stringify(response.data.result));
                    self.$forceUpdate();
                    console.log(">", self.data)
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        },
        setTab: function(tab) {
            var self        = this;
            console.log("setTab()", tab);
            self.tab            = tab;
            self.data.itens     = [];
            self.data.loaded    =false;

            self.$forceUpdate();
            loading.show();
            self.get().finally(function() {
                setTimeout(function() {
                    loading.hide();
                }, 500);                
            });
        },        
    },
    created: function() {
        var self = this;

        loading.show();

        if (self.$route.query.CD_PESSOA_FISICA) {
            self.form.CD_PESSOA_FISICA = self.$route.query.CD_PESSOA_FISICA;
        }

        if (self.$route.query.t == "atestados") {
            self.tab    = "atestados";
        }

        self.$root.addLog({
            "acao": "VISUALIZAR_RECEITAS_ATESTADOS", 
            "pessoaFisicaCod": self.form.CD_PESSOA_FISICA ? self.form.CD_PESSOA_FISICA : ""
        });

        Promise.all([
            self.get()
        ]).then(function() {
        
            setTimeout(function() {
                loading.hide();
            }, 500);
            
        }).catch(function(error) {
            loading.hide();
        });         

    },
    mounted: function() {
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .table td button i {
        font-size: 20px !important;
        color: #fff;
    }
    .table td button {
        margin-top: 0px !important;
    }
    .table td {
        /*border-right: none;*/
        /*border-left: none;*/
    }
    .table td input, .table td select {
        margin-top: 0px;
        margin-bottom: 0px;
        text-align: left
    }
    .read-only {
        pointer-events: none !important;
        -webkit-touch-callout: none;                /* prevent callout to copy image, etc when tap to hold */
        -webkit-text-size-adjust: none;             /* prevent webkit from resizing text to fit */
        -webkit-user-select: none;             
    }
    .attachment-box {
        border: none !important;
        padding-bottom: 15px;
/*        display: block !important;
        position: relative;*/
    }
    div.float-right {
        float: right;
        display: inline-block;
    }
    .buttons {
        /*position: absolute;*/
        /*top: 10px;*/
        /*right: 25px; */
        margin-top: 10px;       
    }
    .attachment-box small div {
        font-size: 12px;
    }
    .attachment-box small {
        color: #888;
        display: block;
        font-weight: 300;
    }
    .attachment-box span {
        font-size: 16px !important;
        margin-bottom: 5px;
    }
    .dashboard-status-button {
     
        margin-right: 5px;
        line-height: 32px;
    }
    .dashboard-status-button i {
        color: #fff;
        top: 0px;
        display: inline-block !important;
    }

    .tabs-header a {
        font-size: 16px;
        font-weight: 300;
        color: #fff;
    }

    .tabs-default ul {
        background: #00995d;
    }

    .tabs-default .active a {
        /*font-weight: bold;*/
    }

    .tabs-default .active {
        background: rgba(255,255,255,0.2) !important;
    }

    .button.outline {
        box-shadow: none !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Receitas.vue